
<template>
  <div id="corte">
  <v-breadcrumbs :items="breadcrumbs">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12>
          <base-material-card
            color="primary"
            icon="mdi-cash-register"
            title="Administrar Pagos"
            class="elevation-1 px-5 py-3"
          >
            <v-card-actions>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                class="ml-auto"
                label="Buscar"
                hide-details
                style="max-width: 250px;"
              />
              <v-spacer />

              <v-btn
                fab
                dark
                x-small
                color="primary"
                slot="activator"
                @click.native="agregar"
                title="Agregar Registro"
                v-tippy
              >
                <v-icon dark>add</v-icon>
              </v-btn>
            </v-card-actions>

            <v-card-text>
            
            </v-card-text>
          </base-material-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>



<script>
import moment from "moment";
export default {
  name: "Corte",
  data: () => ({
    tabla: "",
    modal: false,
        breadcrumbs: [
      {
        text: "Inicio",
        disabled: false,
        to: "/home",
      },
      {
        text: "Pagos",
        disabled: true,
        href: "",
      },
    ],

    rules: {},
    headers: [],
    items: [],
    search: undefined,
  }),
  computed: {
  
  },
  methods: {
  
  
  },
  created: function () {       
  },
};
</script>
